import React, { useState } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { useSelector } from 'react-redux';
import Company from 'services/api/Company';
import isSuperAdminSelector from 'store/selectors/isSuperAdmin';
import { I18n } from 'utils/i18n';

const SanitizeCompanyButton = ({ companyId, disabled = false }) => {
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  if (!isSuperAdmin || !companyId) {
    return null;
  }

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleSanitize = async () => {
    const confirmed = window.confirm(I18n.t('CompanyDrawer.Confirm sanitize company'));
    if (!confirmed) {
      return;
    }

    setIsLoading(true);
    try {
      await Company.sanitize(companyId);
      setSnackbar({
        open: true,
        severity: 'success',
        message: I18n.t('CompanyDrawer.Company sanitized successfully'),
      });
    } catch (error) {
      const message =
        error?.data?.message ||
        error?.message ||
        I18n.t('CompanyDrawer.Company sanitization failed');
      setSnackbar({
        open: true,
        severity: 'error',
        message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="error"
        startIcon={<CleaningServicesIcon />}
        onClick={handleSanitize}
        disabled={disabled || isLoading}
        sx={{ minWidth: 140 }}
      >
        {isLoading ? I18n.t('CompanyDrawer.Sanitizing') : I18n.t('CompanyDrawer.Sanitize')}
      </Button>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SanitizeCompanyButton;
